import {
  Button,
  Card,
  CardContent,
  CardFooter,
  Tooltip,
  TooltipProvider,
  TooltipTrigger,
} from '@bpinternal/ui-kit-next'
import { useRouter } from '@tanstack/react-router'
import { useDeleteBot } from '~/hooks'
import { showBotDeletionPrompt } from '../../utils/botDeletionPrompt'

type BotDangerZoneProps = { botId: string; workspaceId: string; botName: string }

export const BotDangerZone = ({ botId, workspaceId, botName }: BotDangerZoneProps) => {
  const { mutate: deleteBot } = useDeleteBot(workspaceId)
  const router = useRouter()

  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="pb-2 text-lg text-red-600">Delete Bot</h3>
        <p className="text-neutral-900">
          Deleting this bot is an irreversible process and will permanently erase the data associated with this bot.
        </p>
      </CardContent>
      <CardFooter className="flex justify-end p-6 pt-0">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="destructive"
                onClick={() => {
                  showBotDeletionPrompt(botName).then((confirmed) => {
                    if (confirmed) {
                      deleteBot({
                        id: botId,
                        options: {
                          onSuccess: async () => {
                            await router.navigate({
                              to: '/workspaces/$workspaceId/home',
                              params: {
                                workspaceId,
                              },
                            })
                          },
                        },
                      })
                    }
                  })
                }}
              >
                Delete Bot
              </Button>
            </TooltipTrigger>
          </Tooltip>
        </TooltipProvider>
      </CardFooter>
    </Card>
  )
}
